import JustificacionService from "@/api/services/personal/empleado/JustificacionService"
import Vue from "vue"

const state = () => ({
    justificaciones: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    JUSTIFICACIONES: state => {
        return state.justificaciones
    },
    JUSTIFICACIONES_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_JUSTIFICACIONES: (state, payload) => {
        state.justificaciones = payload
    },

    SET_JUSTIFICACIONES_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_JUSTIFICACION: (state, payload) => {
        state.justificaciones.push(payload)
    },

    UPDATE_JUSTIFICACION: (state, payload) => {
        state.justificaciones = state.justificaciones.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_JUSTIFICACION: (state, payload) => {
        state.justificaciones = state.justificaciones.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_JUSTIFICACIONES: async ({ commit, state }, { filter, justificacionEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await JustificacionService.get({
                filter,
                justificacionEstado,
                ...pagination
            })
            if (status === 200) {
                commit("SET_JUSTIFICACIONES", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las justificaciones, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_JUSTIFICACIONES: async ({ commit }) => {
        try {
            let { data, status } = await JustificacionService.getAll()
            if (status === 200) {
                commit("SET_JUSTIFICACIONES", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_JUSTIFICACIONES: async ({ commit }) => {
        try {
            let { data, status } = await JustificacionService.getAllRecords()
            if (status === 200) {
                commit("SET_JUSTIFICACIONES", data)
                return data
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las justificaciones, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_JUSTIFICACION: async ({ commit }, payload) => {
        try {
            let { data, status } = await JustificacionService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_JUSTIFICACION", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial de la justificación, inténtelo nuevamente"
            })
        }
    },

    ADD_JUSTIFICACION: async ({ commit }, payload) => {
        try {
            let { data, status } = await JustificacionService.post(payload)
            if (status === 201) {
                commit("ADD_JUSTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "La justificación ha sido agregada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar la justificación, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_JUSTIFICACION: async ({ commit }, payload) => {
        try {
            let { data, status } = await JustificacionService.put(payload)
            if (status === 200) {
                commit("UPDATE_JUSTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La justificación ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la justificación, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_JUSTIFICACION: async ({ commit }, payload) => {
        try {
            let { status, data } = await JustificacionService.delete(payload)
            if (status === 204) {
                commit("DELETE_JUSTIFICACION", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El justificación ha sido eliminada satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_JUSTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "La justificación ha sido deshabilitada satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshalitar la justificación, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
